export const getAuthHeaders = () => ({
  sessionToken: localStorage.getItem('sessionToken'),
});
